<template lang="pug">
MapItemObject(
  v-if="mapdata.type == 'object'"
  :maptype="maptype"
  :mapdata="mapdata"
)
MapItemMaptypeBtn(
  v-else-if="mapdata.type == 'maptypebtn'"
  :maptype="maptype"
  :mapdata="mapdata"
)
MapItemPin(
  v-else-if="mapdata.id"
  :maptype="maptype"
  :mapdata="mapdata"
)
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

// @media screen and (min-width: ($BREAKPOINT + 1))
// @media screen and (max-width: ($BREAKPOINT))

</style>


<script>
import { defineComponent,onMounted } from "vue"
import { useStore } from '@/store'
import MapItemPin from './MapItemPin'
import MapItemObject from './MapItemObject'
import MapItemMaptypeBtn from './MapItemMaptypeBtn'

export default defineComponent({
  name:'MapItem',

  components:{MapItemPin,MapItemObject,MapItemMaptypeBtn},

  props:{
    maptype:{
      type:Number,
      default: 1
    },
    mapdata:{
      type:Object,
      default: function() {
        return {}
      }
    }
  },

  setup(props, context) {
    const store = useStore()

    onMounted(()=>{
    })

    return{
      store
    }
  }
})
</script>
